import { SYSTEM_INPUT } from './topics';
import { Joi, actionCreator, literalAs, objectSchemaOf } from '../helpers';

export const STATUS_POLL = 'SYSTEM/STATUS_POLL' as const;

export interface IStatusPoll {
  type: typeof STATUS_POLL;
}

export const statusPollActionSchema = objectSchemaOf<IStatusPoll>({
  type: Joi.string().valid(STATUS_POLL).required(),
});

export const statusPoll = actionCreator({
  type: STATUS_POLL,
  topic: SYSTEM_INPUT,
  schema: statusPollActionSchema,
  creator: () => literalAs<IStatusPoll>({ type: STATUS_POLL }),
});
